import http from '../http';
import map from './config.map.json';

export interface GetResponse {
	feedbackLink: string;
}

function get() {
	return http.get<GetResponse>('/ext-sync', { map });
}

export default {
	get
} as const;
